import Giubileo from "../";

const routes = [
  { name: "GiubileoSchedaListPage", path: "/giubileoscheda", component: Giubileo.GiubileoSchedaListPage, meta: { title: "Giubileo Scheda" } },
  { name: "GiubileoSchedaEditPage", path: "giubileoscheda/edit/:id", component: Giubileo.GiubileoSchedaEditPage, meta: { title: "Giubileo Scheda" } },
];

export default routes;
